import { DefaultLayout } from 'layouts/DefaultLayout';

import { useOthers } from './Others.hooks';
import * as S from './Others.styles';

export function Others(): React.ReactElement {
  const { listInfoMapped, infoItemsMapped } = useOthers();

  return (
    <DefaultLayout isNested withHeader>
      <S.Wrapper>
        <S.WrapperInfo>
          <S.Info>{listInfoMapped}</S.Info>

          <S.List>
            <S.HeadlineInfo fontWeight="light" tag="h4">
              List
            </S.HeadlineInfo>

            <S.Info asList>{infoItemsMapped}</S.Info>
          </S.List>
        </S.WrapperInfo>
      </S.Wrapper>
    </DefaultLayout>
  );
}
